export default {
  settings: {
    visited: null,
    lastViewedVersion: '0.0.1',
    viewedSubscriptionExpired: null,
    devicesUpdated: [],
    movedToAnotherDeviceMessages: [],
    showDataGapLine: null,
  },
}
